var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3697 -2.05792e-05H2.03098C1.29622 -2.05792e-05 0.702077 0.580058 0.702077 1.29725V16.6992C0.702077 17.4164 1.29622 18 2.03098 18H17.3697C18.1044 18 18.7021 17.4164 18.7021 16.7027V1.29725C18.7021 0.580058 18.1044 -2.05792e-05 17.3697 -2.05792e-05ZM6.04231 15.3387H3.37044V6.74646H6.04231V15.3387ZM4.70637 5.57576C3.84856 5.57576 3.15598 4.88318 3.15598 4.02889C3.15598 3.17459 3.84856 2.48201 4.70637 2.48201C5.56067 2.48201 6.25325 3.17459 6.25325 4.02889C6.25325 4.87967 5.56067 5.57576 4.70637 5.57576ZM16.0407 15.3387H13.3724V11.1621C13.3724 10.1672 13.3548 8.88396 11.9837 8.88396C10.595 8.88396 10.3841 9.97029 10.3841 11.0918V15.3387H7.71926V6.74646H10.2786V7.92068H10.3138C10.6689 7.24568 11.5407 6.53201 12.838 6.53201C15.5415 6.53201 16.0407 8.31092 16.0407 10.6242V15.3387Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.1afc44b9255974bac8c52eb80a80d267.svg";
export { ForwardRef as ReactComponent };